import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { BASE_MOBILE_API_URL, BASIC_AUTH } from "../constants";
import axios from "axios";
import { notifyError, notifySuccess } from "../components/notify";
import TableLoader from "../components/Spinner/TableLoader";
import { ToastContainer } from "react-toastify";
import LogoLoader from "../components/Spinner/logoLoader";

const CompanyListPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [companyList, setCompanyList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const flag = location.state?.flag;
  const mobile = location.state?.mobile;
  const password = location.state?.password;

  const handleSelectSignup = (company) => {
    navigate("/signup", {
      state: { company },
    });
  };

  const getCompanyList = useCallback(async () => {
    setLoading(true);
    const shouldSendMobile = flag === "fromSignin" || flag === "fromForgetPass";

    try {
      const response = await axios.get(
        `${BASE_MOBILE_API_URL}/get_company_list`,
        {
          params: {
            mobileno: shouldSendMobile ? mobile : "0",
            ...(password ? { password } : {}),
          },
          headers: {
            Authorization: BASIC_AUTH,
          },
        },
      );

      const result = response.data;
      setCompanyList(result);
    } catch (err) {
      console.error(err);

      if (err.response) {
        // Server responded with error status
        const errorMessage =
          err.response?.data && typeof err.response.data === "string"
            ? err.response.data
            : err.response?.data?.message ||
              err.response?.data?.error ||
              "Fatch company list failed";

        notifyError(errorMessage);
        if (flag === "fromSignin") {
          navigate("/signin", {
            state: { mobileno: mobile },
          });
        }
      } else if (err.request) {
        // No response received
        notifyError("Server not responding. Please try again.");
      } else {
        // Other errors
        notifyError("Something went wrong.");
      }
    } finally {
      setLoading(false);
    }
  }, [flag, mobile, password]);

  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;

    hasFetched.current = true;
    getCompanyList();
  }, [getCompanyList]);
  const handleCustomerSubmit = async (company) => {
    setLoading1(true);
    try {
      const response = await axios.get(`${BASE_MOBILE_API_URL}/customerLogin`, {
        params: {
          mobileno: mobile,
          password: password,
          companycode: company.companycode,
          branchcode: company.branchcode,
        },
        headers: {
          Authorization: BASIC_AUTH,
        },
      });

      const result = response.data;

      sessionStorage.setItem("loginuser", "true");
      localStorage.setItem("loginuser", "true");

      localStorage.setItem("loginusertype", "customer");

      localStorage.setItem("customerInfo", JSON.stringify(response.data));

      notifySuccess(result.RESMSG || "Login successful");
      navigate("/dashboard", { replace: true });
    } catch (err) {
      if (err.response) {
        const errorMessage =
          typeof err.response.data === "string"
            ? err.response.data
            : err.response.data?.message ||
              err.response.data?.error ||
              err.response.data?.RESMSG ||
              "Login failed";

        notifyError(errorMessage);
      } else if (err.request) {
        notifyError("Server not responding. Please try again.");
      } else {
        notifyError("Something went wrong.");
      }
    } finally {
      setLoading1(false);
    }
  };

  const handleForgetPass = async (company) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${BASE_MOBILE_API_URL}/customer_forget_password`,
        {
          companycode: company?.companycode,
          branchcode: company?.branchcode,
          mobileno: mobile,
        },
        {
          headers: {
            Authorization: BASIC_AUTH,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status === 200) {
        notifySuccess("Password changed successfully!");
        navigate("/signin", {
          replace: true,
        });
      }
    } catch (err) {
      console.error(err);

      if (err.response) {
        // Server responded with error status
        const errorMessage =
          err.response?.data && typeof err.response.data === "string"
            ? err.response.data
            : err.response?.data?.message ||
              err.response?.data?.error ||
              "Forget password failed";

        notifyError(errorMessage);
      } else if (err.request) {
        // No response received
        notifyError("Server not responding. Please try again.");
      } else {
        // Other errors
        notifyError("Something went wrong.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading1 && <LogoLoader message="Loading ..." />}
      <div className="container-fluid min-vh-100 bg-black px-0">
        <div className="company-page">
          {/* {flag !== "fromSignin" && ( */}
          <div className=" mb-2 d-flex justify-content-end">
            <button
              type="button"
              className="back-btn"
              onClick={() =>
                navigate("/signin", {
                  replace: true,
                  state: { fromSignup: true },
                })
              }
            >
              <i className="fa-solid fa-arrow-left me-2"></i> Back to Sign In
            </button>
          </div>
          {/* )} */}
          <h2 className="company-title ">Company List</h2>

          {loading ? (
            <TableLoader
              message={`Loading company list...`}
              size="sm"
              messageClass="tablemessage-white"
              spinnerClass="tablespinner-white"
            />
          ) : (
            companyList.map((company, index) => (
              <div className="row justify-content-center">
                <div className="col-12 col-md-6 col-lg-4">
                  <div
                    key={index}
                    className="company-card"
                    onClick={() =>
                      flag === "fromSignin"
                        ? handleCustomerSubmit(company)
                        : flag === "fromForgetPass"
                          ? handleForgetPass(company)
                          : handleSelectSignup(company)
                    }
                  >
                    <div className="company-left">
                      <img
                        src={
                          company.company_image
                            ? company.company_image
                            : "/assest/company-logo.png"
                        }
                        alt="logo"
                      />
                    </div>

                    <div className="company-right">
                      <div className="col-12 company-font-size">
                        <span className="company-label col-5">
                          Company Name :
                        </span>
                        <span className="company-value">
                          {company.company_name}
                        </span>
                      </div>

                      <div className="col-12 company-font-size">
                        <span className="company-label col-5 ">
                          Branch Name :
                        </span>
                        <span className="company-value">
                          {company.branchname}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  );
};

export default CompanyListPage;
